import * as React from 'react';
const SvgVim = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={1200}
    height={800}
    viewBox='-79.144 -132.083 685.913 792.501'
    {...props}
  >
    <g stroke='#000'>
      <path
        fill='#019833'
        strokeWidth={0.946}
        d='M260.507 170.695 105.984 340.791l153.88 169.387 154.523-170.096z'
        transform='matrix(1.53239 0 0 1.39397 -133.166 -210.39)'
      />
      <path
        fill='#66fe98'
        strokeWidth={0.946}
        d='M259.864 171.404V156.52L91.819 341.5h14.165z'
        transform='matrix(1.53239 0 0 1.39397 -133.166 -210.39)'
      />
      <path
        fill='#45fe02'
        strokeWidth={0.946}
        d='M259.477 171.404V156.52L427.521 341.5h-14.164z'
        transform='matrix(1.53239 0 0 1.39397 -133.166 -210.39)'
      />
      <path
        fill='#017d17'
        strokeWidth={0.946}
        d='M259.864 511.17v14.884L91.819 341.074h14.165z'
        transform='matrix(1.53239 0 0 1.39397 -133.166 -210.39)'
      />
      <path
        fill='none'
        strokeWidth={18.914}
        d='M122.994 175.306h108.354l6.602 7.267v22.301l-5.236 7.016h-11.837v110.754l101.98-110.754h-16.845l-5.918-7.016V181.32l5.463-5.512h109.72l5.463 6.013v22.05L172.62 484.016h-28.227l-8.17-5.193V210.888H122.54l-5.008-5.513v-23.554z'
        transform='matrix(1.53239 0 0 1.39397 -133.166 -210.39)'
      />
      <path
        fill='#005d04'
        strokeWidth={0.946}
        d='M259.477 511.17v14.884l168.044-184.98h-14.164z'
        transform='matrix(1.53239 0 0 1.39397 -133.166 -210.39)'
      />
      <path
        fill='none'
        strokeWidth={5.674}
        d='M259.41 155.148 90.734 340.823l167.973 184.902L427.384 340.05z'
        transform='matrix(1.53239 0 0 1.39397 -133.166 -210.39)'
      />
      <path
        fill='#fefefe'
        strokeWidth={0.946}
        d='m232.5 186.642 6.117-3.544-6.278-6.91H123.046l-5.553 6.113v23.122l6.157 6.777 2.937-6.777-3.863-4.252V184.87l2.897-2.835h104.304z'
        transform='matrix(1.53239 0 0 1.39397 -133.166 -210.39)'
      />
      <path
        fill='none'
        d='m828.938 369.5-4.282 4.281V389.5l3.75 3.75h19.813v15.188L717.156 541.28V393.438h21.782l4.468-4.47v-15.906l-4.125-3.187H624.656l-3.75 3.75v16.25l3.813 3.813h19.937v272.25l3.75 3.75h22.657L945.718 386.28v-12.5l-4.282-4.281z'
        transform='matrix(1.38127 0 0 1.38313 -803.468 -468.7)'
      />
      <path
        fill='#fefefe'
        strokeWidth={0.946}
        d='M143.482 204.874v270.621l3.186 4.01-2.499 5.242-7.061-7.749V211.89z'
        transform='matrix(1.53239 0 0 1.39397 -133.166 -210.39)'
      />
      <path
        fill='gray'
        strokeWidth={0.946}
        d='m125.825 204.874-1.822 6.515h13.203l7.285-6.515z'
        transform='matrix(1.53239 0 0 1.39397 -133.166 -210.39)'
      />
      <path
        fill='#fefefe'
        strokeWidth={0.946}
        d='m307.186 212.191 2.898-6.555-4.185-4.253v-14.529l4.829-5.315H411.49l3.863 5.67 5.472-4.253-5.633-6.201H306.864l-5.392 5.935v23.3l5.594 5.803M219.523 323.67 209 351.776l118.79-131.115v-15.592z'
        transform='matrix(1.53239 0 0 1.39397 -133.166 -210.39)'
      />
      <path
        fill='gray'
        strokeWidth={0.946}
        d='m232.259 185.83 5.236-3.758v22.802l-6.033 6.64H219.74v112.383l-10.699 27.814V204.874h19.577l3.642-3.257z'
        transform='matrix(1.53239 0 0 1.39397 -133.166 -210.39)'
      />
      <path
        fill='#ccc'
        d='m828.938 369.5-4.282 4.281V389.5l3.75 3.75h19.813v15.188L717.156 541.28V393.438h21.782l4.468-4.47v-15.906l-4.125-3.187H624.656l-3.75 3.75v16.25l3.813 3.813h19.937v272.25l3.75 3.75h22.657L945.718 386.28v-12.5l-4.282-4.281z'
        transform='matrix(1.38127 0 0 1.38313 -803.468 -468.7)'
      />
      <path
        fill='gray'
        strokeWidth={0.946}
        d='m415.353 185.933 5.498-3.495v21.922l-249.39 280.52h-26.478l2.53-5.533h20.28l247.238-281.012zm-88.057 19.317-5.577 6.39h-14.568l3.414-6.39h16.731z'
        transform='matrix(1.53239 0 0 1.39397 -133.166 -210.39)'
      />
      <g fill='#ccc' strokeMiterlimit={10}>
        <path
          strokeWidth={8}
          d='M399.781 560a1.233 1.233 0 0 0-.562.281l-5.313 4.563a1.233 1.233 0 0 0-.344.531l-5.312 14.875a1.233 1.233 0 0 0 .281 1.281l4.063 4.063a1.233 1.233 0 0 0 .875.343h16.406a1.233 1.233 0 0 0 .875-.343l4.281-4.313a1.233 1.233 0 0 0 .313-.531l4.562-15.656a1.233 1.233 0 0 0-.312-1.219l-3.531-3.531a1.233 1.233 0 0 0-.875-.344H400.03a1.233 1.233 0 0 0-.25 0zm-30.062 41.938a1.233 1.233 0 0 0-.938.906l-2.031 8.062a1.233 1.233 0 0 0 1.188 1.532h9.656l-23.938 68.343a1.233 1.233 0 0 0 1.156 1.625h34.844a1.233 1.233 0 0 0 1.188-.843l2.281-7.344a1.233 1.233 0 0 0-1.188-1.594h-7.875l23.688-69.063a1.233 1.233 0 0 0-1.156-1.625h-36.625a1.233 1.233 0 0 0-.25 0zm110.875.25a1.233 1.233 0 0 0-.688.406l-7.25 8.187h-11.531l-7.688-7.968a1.233 1.233 0 0 0-.875-.375h-27.53a1.233 1.233 0 0 0-1.157.812l-2.531 7.563a1.233 1.233 0 0 0 1.156 1.625h7.375l-22.938 67.593a1.233 1.233 0 0 0 1.157 1.625h29.312a1.233 1.233 0 0 0 1.156-.812l2.25-6.594a1.233 1.233 0 0 0-1.156-1.625h-5.125l14.625-46.031h26.469l-16.688 53.468a1.233 1.233 0 0 0 1.188 1.594h28.281a1.233 1.233 0 0 0 1.125-.75l2.531-6.062a1.233 1.233 0 0 0-1.125-1.688h-5.125l14.875-46.812h25.188l-16.938 53.718a1.233 1.233 0 0 0 1.188 1.594h31.063a1.233 1.233 0 0 0 1.156-.781l2.531-6.594a1.233 1.233 0 0 0-1.156-1.656h-6.157l18.72-60.781a1.233 1.233 0 0 0-.188-1.125l-5.813-7.813a1.233 1.233 0 0 0-1-.468h-22.218a1.233 1.233 0 0 0-.907.375l-7 7.687h-12.25l-7.25-7.938a1.233 1.233 0 0 0-.906-.375h-17.906a1.233 1.233 0 0 0-.25 0z'
          transform='matrix(1.38127 0 0 1.38313 -274.958 -478.364)'
        />
        <path
          d='m400.031 561.219-5.312 4.562-5.313 14.875 4.063 4.063h16.406l4.281-4.313 4.563-15.656-3.531-3.531zm-30.062 41.937-2.031 8.063h11.375l-24.5 69.968h34.843l2.281-7.343h-9.593l24.25-70.688zm110.875.25L473.25 612h-12.625l-8.063-8.344h-27.53l-2.532 7.563h9.094l-23.5 69.218h29.312l2.25-6.593h-6.812l15.406-48.469h29.063l-17.188 55.063h28.281l2.531-6.063h-6.812l15.656-49.25h27.781l-17.437 55.313h31.063l2.53-6.594h-7.843l19.219-62.375-5.813-7.813h-22.218l-7.344 8.063h-13.375l-7.594-8.313z'
          transform='matrix(1.38127 0 0 1.38313 -274.958 -478.364)'
        />
      </g>
    </g>
  </svg>
);
export default SvgVim;
